export default {"src":"/_next/static/media/card-subscriptions.dbb514c3.svg","height":65,"width":84,"blurWidth":0,"blurHeight":0};